import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AskAuntyOrUncleComponent from '../../components/AskAuntyOrUncle';
import { getAuntiesRequest } from '../../actionCreators/auntiesActions';

const AskAuntyOrUncle = (props) => <AskAuntyOrUncleComponent {...props} />;

const AskAuntyOrUncleContainer = (props) => {
  const state = useSelector((state) => ({
    aunties: state.aunties.aunties,
  }));

  const dispatch = useDispatch();

  const actions = {
    getAunties: (payload) => dispatch(getAuntiesRequest(payload)),
  };

  return <AskAuntyOrUncle {...props} {...state} {...actions} />;
};

export default AskAuntyOrUncleContainer;
